import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';

const HtmlImportDropzone = memo(
    ({
        className = '',
        error,
        isDraggingFile = false,
        hideError = false,
        onOpenFileSelector,
        onDrop,
        onDragEnter,
        onDragOver,
        onDragLeave,
        onKeyDown,
    }) => {
        const theme = useTheme();
        const dropzoneClassName = [
            'marketing-html-editor__dropzone',
            isDraggingFile ? 'marketing-html-editor__dropzone--dragging' : '',
        ]
            .filter(Boolean)
            .join(' ');
        const rootClassName = ['marketing-html-editor__empty-preview', className]
            .filter(Boolean)
            .join(' ');

        return (
            <div className={rootClassName}>
                <div
                    className={dropzoneClassName}
                    role="button"
                    tabIndex={0}
                    onClick={onOpenFileSelector}
                    onKeyDown={onKeyDown}
                    onDragEnter={onDragEnter}
                    onDragOver={onDragOver}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}
                >
                    <div className="marketing-html-editor__dropzone-heading">
                        <Icon
                            name="cloudUpload"
                            size="large"
                            color={theme.colors.actionMinor[500]}
                            className="marketing-html-editor__dropzone-icon"
                        />
                        <Text type="body" className="marketing-html-editor__dropzone-title">
                            {getLiteralWithParameters(
                                'label_marketing_campaigns_editor_drag_drop_file',
                                [getLiteral('label_marketing_campaigns_editor_attach')],
                            )}
                        </Text>
                    </div>
                    <Text
                        type="caption"
                        className="marketing-html-editor__dropzone-subtitle"
                        color={theme.colors.grey[500]}
                    >
                        {getLiteral('label_marketing_campaigns_editor_drag_drop_desc')}
                    </Text>
                    <Button
                        type="secondary"
                        className="marketing-html-editor__dropzone-button"
                        onClick={(event) => {
                            event.stopPropagation();
                            onOpenFileSelector?.();
                        }}
                    >
                        {getLiteral('action_marketing_campaigns_editor_select_file')}
                    </Button>
                </div>
                {!hideError && error && (
                    <Text
                        type="caption"
                        className="marketing-html-editor__error-copy"
                        color={theme.colors.semantic.negative500}
                    >
                        {error}
                    </Text>
                )}
            </div>
        );
    },
);

HtmlImportDropzone.displayName = 'HtmlImportDropzone';

HtmlImportDropzone.propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    isDraggingFile: PropTypes.bool,
    hideError: PropTypes.bool,
    onOpenFileSelector: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    onDragEnter: PropTypes.func.isRequired,
    onDragOver: PropTypes.func.isRequired,
    onDragLeave: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

export default HtmlImportDropzone;
